<template>
  <BaseVeeForm :action="submit" v-slot="formProps" @success="closeModal">
    <VModal ref="modal" disable-backdrop-click @close="$emit('close')">
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-lg sm:w-full">
        <div class="flex flex-col divide-y">
          <div class="flex-none p-4">
            <div class="flex justify-between items-center">
              <div class="flex-1">{{ defaultData.id ? 'Update' : 'Create' }} audience</div>
              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="closeModal"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 p-4 space-y-8">
            <AudienceNameInput v-model="formData.name" :disabled="formProps.isPending" />
            <AudienceDescriptionInput
              v-model="formData.description"
              :disabled="formProps.isPending"
            />
            <MediaSelectInput v-model="formData.cover" />
            <template v-if="!defaultData.id">
              <BaseFormSelectFieldWithValidator
                v-model="formData.source"
                :validator="{
                  name: 'source',
                  vid: 'source',
                  rules: {
                    required: true,
                  },
                }"
                :field="{
                  label: 'Source',
                  id: 'saved_query_source',
                  options: [
                    { value: 'saved_query', label: 'Saved Query' },
                    { value: 'facebook', label: 'Facebook' },
                    { value: 'google_ads', label: 'Google Ads' },
                  ],
                  required: true,
                }"
                :disabled="formProps.isPending"
              />
              <template v-if="formData.source === 'facebook'">
                <AdAccountSelect
                  v-model="formData.facebook_ad_account_id"
                  :disabled="formProps.isPending"
                />
                <FacebookAudienceTypeSelect
                  v-model="formData.facebook_audience_type"
                  :disabled="formProps.isPending"
                />
                <FacebookAudienceIdInput
                  v-model="formData.facebook_audience_id"
                  :disabled="formProps.isPending"
                />
              </template>
              <template v-if="formData.source === 'google_ads'">
                <GoogleAdsCustomerSelect
                  v-model="formData.ga_customer_id"
                  :disabled="formProps.isPending"
                />
                <GoogleAdsUserListSelect
                  v-if="formData.ga_customer_id"
                  v-model="formData.ga_user_list_id"
                  :ga-customer-id="formData.ga_customer_id"
                  :disabled="formProps.isPending"
                />
              </template>
              <template v-if="formData.source === 'saved_query' && typeof accountId === 'string'">
                <SavedQuerySelect
                  v-model="formData.saved_query_id"
                  :account-id="accountId"
                  :disabled="formProps.isPending"
                />
              </template>
            </template>
            <div class="flex space-x-2">
              <BaseButton primary> Save </BaseButton>
              <BaseButton type="button" ghost @click="$refs.modal.close()"> Cancel </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
import { pick } from 'lodash-es';
import AudienceNameInput from './audienceModal/AudienceNameInput.vue';
import AudienceDescriptionInput from './audienceModal/AudienceDescriptionInput.vue';
import AdAccountSelect from './audienceModal/AdAccountSelect.vue';
import SavedQuerySelect from './audienceModal/SavedQuerySelect.vue';
import FacebookAudienceTypeSelect from './audienceModal/FacebookAudienceTypeSelect.vue';
import FacebookAudienceIdInput from './audienceModal/FacebookAudienceIdInput.vue';
import GoogleAdsCustomerSelect from './audienceModal/GoogleAdsCustomerSelect.vue';
import GoogleAdsUserListSelect from './audienceModal/GoogleAdsUserListSelect.vue';
import MediaSelectInput from './audienceModal/MediaSelectInput.vue';

export default {
  name: 'AudienceModal',
  components: {
    AudienceNameInput,
    AudienceDescriptionInput,
    AdAccountSelect,
    FacebookAudienceTypeSelect,
    FacebookAudienceIdInput,
    SavedQuerySelect,
    GoogleAdsCustomerSelect,
    GoogleAdsUserListSelect,
    MediaSelectInput,
  },
  props: {
    exists: Boolean,
    accountId: {
      type: String,
      default: () => null,
    },
    action: {
      type: Function,
      default: () => Promise.resolve(),
    },
    defaultData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  created() {
    this.setupFormData();
  },
  methods: {
    setupFormData() {
      const attributes = [
        'name',
        'description',
        'cover',
        ...(this.defaultData.id
          ? []
          : [
              'source',
              'facebook_ad_account_id',
              'facebook_audience_type',
              'facebook_audience_id',
              'saved_query_id',
            ]),
      ];

      this.formData = {
        ...pick(this.defaultData, attributes),
      };
    },
    async submit() {
      const { cover, ...restFormData } = this.formData;

      const data = {
        cover: cover?.id || null,
        ...restFormData,
      };

      try {
        await this.action(data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
